import { useState } from "react";
import { toast } from "sonner";
import PublicShell from "@/components/PublicShell";
import { VideoSlot } from "@/components/VideoSlot";
import { api } from "@/lib/api";

export default function CustomRequestPage() {
  const [f, setF] = useState({ name: "", email: "", phone: "", description: "", desired_size: "", budget: "", style_reference: "" });
  const [sending, setSending] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/custom-requests", f);
      toast.success("Request received. Jason will be in touch soon.");
      setF({ name: "", email: "", phone: "", description: "", desired_size: "", budget: "", style_reference: "" });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to send");
    } finally { setSending(false); }
  };
  return (
    <PublicShell>
      <section className="max-w-4xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <VideoSlot page="custom" spot="top" className="mb-16" />
        <div className="overline text-mute mb-4">Commission a Piece</div>
        <h1 className="font-serif text-5xl md:text-6xl font-light leading-tight mb-6 text-ink">Something made only for you.</h1>
        <p className="text-ink-soft leading-relaxed mb-12 max-w-2xl">
          Tell me about the piece you&apos;re imagining — the room it will live in, a memory, or a mood you keep returning to. I&apos;ll respond within 2 business days with a proposal.
        </p>
        <form onSubmit={submit} className="space-y-6" data-testid="custom-request-form">
          <div className="grid md:grid-cols-2 gap-6">
            <input required className="input-line" placeholder="Your name" data-testid="custom-name" value={f.name} onChange={e => setF({ ...f, name: e.target.value })} />
            <input required type="email" className="input-line" placeholder="Email" data-testid="custom-email" value={f.email} onChange={e => setF({ ...f, email: e.target.value })} />
          </div>
          <div className="grid md:grid-cols-2 gap-6">
            <input className="input-line" placeholder="Phone (optional)" data-testid="custom-phone" value={f.phone} onChange={e => setF({ ...f, phone: e.target.value })} />
            <input className="input-line" placeholder="Desired size (e.g. 24x36)" data-testid="custom-size" value={f.desired_size} onChange={e => setF({ ...f, desired_size: e.target.value })} />
          </div>
          <input className="input-line" placeholder="Budget range (optional)" data-testid="custom-budget" value={f.budget} onChange={e => setF({ ...f, budget: e.target.value })} />
          <textarea required rows={6} className="input-line" placeholder="Describe your piece — mood, colors, subject, meaning…" data-testid="custom-description" value={f.description} onChange={e => setF({ ...f, description: e.target.value })} />
          <input className="input-line" placeholder="Style reference (link or piece you love)" data-testid="custom-style" value={f.style_reference} onChange={e => setF({ ...f, style_reference: e.target.value })} />
          <div className="pt-6">
            <button className="btn-ink" type="submit" disabled={sending} data-testid="custom-submit">{sending ? "Sending…" : "Send Request"}</button>
          </div>
        </form>
        <VideoSlot page="custom" spot="bottom" className="mt-20" />
      </section>
    </PublicShell>
  );
}
